<div
  class="card-item-list-item"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  tabindex="0"
  role="button"
  [attr.aria-label]="'Open ' + card().header"
>
  <div class="card-item-list-item-inner">
    <div class="card-item-list-item-image" [style.background]="card().image ? null : gradient()">
      @if (card().image) {
        <ptl-card-image [src]="card().image" [alt]="card().header" [cardIndex]="cardIndex()"></ptl-card-image>
      }
    </div>

    <div class="card-item-list-item-content">
      @if (card().v3CardType || card().collectionType) {
        <span class="card-item-list-type-badge" [ngClass]="typeColorClass()">{{ typeDisplayName() }}</span>
      }
      <h3 class="card-item-list-item-title">{{ card().header }}</h3>
      <div class="card-item-list-item-progress">
        <div class="card-item-list-progress-bar-bg">
          <div class="card-item-list-progress-bar-fill" [style.width.%]="progress()"></div>
        </div>
        <span class="card-item-list-progress-text">{{ progress() }}% complete</span>
      </div>
    </div>

    <ptl-icon [icon]="LucideChevronRight" size="s" class="card-item-list-chevron"></ptl-icon>
  </div>
</div>
